import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const SpreadsheetFileIcon = createSvgIcon(
  <g>
    <rect x="8" y="8" width="48" height="48" rx="10" fill="#217346" />
    <path
      fill="#FFFFFF"
      d="M20.8 20.4h6.4L32 29.6l4.8-9.2h6.4L35.4 32l8.4 11.6h-6.6L32 34.6l-5.2 9H20.2L28.6 32z"
    />
  </g>,
  'SpreadsheetFileIcon',
);
